import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Auto-scrolls the window to the top whenever the route pathname changes.
 * Respects in-page hash navigation (e.g., /#contact) — only scrolls to top
 * when there is no hash in the URL.
 * Must be rendered inside <BrowserRouter>.
 */
const ScrollToTopOnRouteChange = () => {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) return;
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
  }, [pathname, hash]);

  return null;
};

export default ScrollToTopOnRouteChange;
